<div id="ip-common">
  <header>
    @if (!isProduction) {
      <lib-environment-banner></lib-environment-banner>
    }
    <lib-alert-info></lib-alert-info>
    <lib-notification-info></lib-notification-info>
    <lib-skip-to-content mainId="main-content"></lib-skip-to-content>
    <lib-site-header
      [site]="EtjansterSites.Start"
      [sitesToShow]="[
        EtjansterSites.Start,
        EtjansterSites.Ansok,
        EtjansterSites.Projekt,
        EtjansterSites.Bedom,
        EtjansterSites.MinProfil,
      ]"
      [authenticated]="true"
    ></lib-site-header>
  </header>
  <main class="ip-body" id="main-content">
    <div class="container mt-5 position-relative flex-fill">
      <ng-container *transloco="let t">
        <h1 class="heading-size-2">
          {{ t('account_start_welcome', { name: firstName }) }}
        </h1>
        <p>{{ t('account_start_description') }}</p>
        <div class="start-menu row">
          <a class="start-menu-item" [href]="env.ansokanUrl">
            <div class="image-container">
              <img
                src="/assets/e-tjanster/ansokningar-illustration.svg"
                role="presentation"
                [alt]="t('account_start_applications')"
              />
            </div>
            <span class="heading-size-5 start-menu-text col-lg-4">
              {{ t('account_start_applications') }}

              <lib-icon name="chevron-right" class="chevron-right"></lib-icon>
            </span>
          </a>
          <a class="start-menu-item" [href]="env.projektUrl">
            <div class="image-container">
              <img
                role="presentation"
                src="/assets/e-tjanster/projekt-illustration.svg"
                [alt]="t('account_start_projects')"
              />
            </div>
            <span class="heading-size-5 start-menu-text col-lg-4">
              {{ t('account_start_projects') }}

              <lib-icon name="chevron-right" class="chevron-right"></lib-icon>
            </span>
          </a>
          @if (isBedomare) {
            <a class="start-menu-item" [href]="env.bpUrl">
              <div class="image-container">
                <img
                  role="presentation"
                  src="/assets/e-tjanster/bedomningar-illustration.svg"
                  [alt]="t('account_start_assessments')"
                />
              </div>
              <span class="heading-size-5 start-menu-text col-lg-4">
                {{ t('account_start_assessments') }}
                <lib-icon name="chevron-right" class="chevron-right"></lib-icon>
              </span>
            </a>
          }
        </div>
        <ng-template #removedFromAnsokanModal>
          <lib-modal
            [title]="t('removed_from_ansokan_modal_title')"
            [showPrimaryButton]="true"
            [showCloseButton]="false"
            [primaryButtonText]="t('removed_from_ansokan_modal_primary_button')"
            (primaryButton)="removedFromAnsokanModalRef?.hide()"
          >
            <p>
              {{ t('removed_from_ansokan_modal_body') }}
            </p>
          </lib-modal>
        </ng-template>
        <ng-template #bedomareReminderModal>
          <lib-modal
            [title]="t('bedomare_reminder_modal_title')"
            [showPrimaryButton]="true"
            [showSecondaryButton]="true"
            [showCloseButton]="true"
            [primaryButtonText]="t('bedomare_reminder_confirm_btn')"
            [secondaryButtonText]="t('form_cancel')"
            (primaryButton)="confirmBedomareProfile()"
            (secondaryButton)="closeBedomareReminderModal()"
            (closeModal)="closeBedomareReminderModal()"
          >
            <p>
              {{ t('bedomare_reminder_modal_body') }}
            </p>
          </lib-modal>
        </ng-template>
      </ng-container>
    </div>
  </main>
  <lib-site-footer></lib-site-footer>
  @if (showChatbot) {
    <vinnova-chatbot-widget> </vinnova-chatbot-widget>
  }
</div>
<lib-already-logged-in></lib-already-logged-in>
